<template>
  <layout>
    <div slot="content">
      <i-card title="用户组列表">
        <div slot="content">
          <el-table :data="adminGroupList" :border="true">
            <el-table-column prop="id" label="用户组id"></el-table-column>
            <el-table-column prop="name" label="用户组名称"></el-table-column>
            <el-table-column prop="real_name" label="操作" width="380px">
              <div slot-scope="scope">
                <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                <el-button size="mini" type="primary" @click="openPutPrivilege(scope.row)">功能权限</el-button>
                <el-button size="mini" type="warning" @click="openDataScope(scope.row)">数据权限</el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <el-button type="success" size="medium" icon="el-icon-plus" @click="showAddGroup=true">
            添加用户组
          </el-button>
        </div>
      </i-card>
      <el-dialog :visible.sync="showAddGroup" title="添加用户组" width="450px">
        <el-form :model="currGroup" size="small" :rules="validateRules" label-width="95px">
          <el-form-item label="管理组名称" prop="name">
            <el-input v-model="currGroup.name"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="showAddGroup = false">取消</el-button>
          <el-button type="primary" :loading="loading" @click="addGroup">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="privilege.show" title="编辑功能权限" width="600px">
        <el-form :model="currGroup" size="small"  label-width="95px">
          <el-form-item label="管理组名称:" prop="name">
            {{currGroup.name}}
          </el-form-item>
          <el-form-item label="权限点" prop="privilege_ids">
            <el-checkbox-group v-model="privilege.checked_privilege">

              <el-checkbox v-for="(privilege,idx) in privilege.all_privilege_list" :label="privilege.privilege_id" :value="privilege.privilege_id" :key="idx">{{ privilege.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="privilege.show = false">取消</el-button>
          <el-button type="primary" :loading="loading" @click="putPrivileges">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :visible.sync="dataScope.show"
        title="数据权限 — 可管理的产品"
        width="920px"
        @close="onDataScopeClose"
      >
        <div v-loading="dataScope.loading">
          <el-form :inline="true" size="small">
            <el-form-item label="用户组">
              <span>{{ dataScope.groupName }}（id: {{ dataScope.groupId }}）</span>
            </el-form-item>
            <el-form-item label="产品类型">
              <el-select v-model="dataScope.type" placeholder="类型" style="width: 140px" @change="onDataScopeTypeChange">
                <el-option v-for="opt in dataScopeTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="筛选">
              <el-input
                v-model="dataScope.filterText"
                clearable
                placeholder="产品ID / 名称 / 类别"
                style="width: 260px"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="selectAllFiltered">全选当前列表</el-button>
              <el-button size="small" @click="clearFilteredSelection">取消当前列表</el-button>
            </el-form-item>
          </el-form>
          <p style="color:#909399;font-size:12px;margin:0 0 10px;">
            已选 {{ dataScope.selectedIds.length }} 个产品（可跨类型累计）；保存后，该组内非超管账号仅可查看与操作这些产品的订单。
          </p>
          <el-table :data="filteredCatalog" border size="small" max-height="420">
            <el-table-column label="选择" width="64" align="center">
              <template slot-scope="scope">
                <el-checkbox
                  :value="isProductSelected(scope.row.id)"
                  @change="checked => toggleProduct(scope.row.id, checked)"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="产品ID" width="90"></el-table-column>
            <el-table-column prop="title" label="产品名称" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column label="上下架" width="100" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="Number(scope.row.on_sale) === 1"
                  type="success"
                  size="mini"
                  effect="plain"
                >{{ scope.row.on_sale_name }}</el-tag>
                <el-tag
                  v-else
                  type="info"
                  size="mini"
                  effect="plain"
                >{{ scope.row.on_sale_name }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="category_names" label="产品类别" min-width="160" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div slot="footer">
          <el-button @click="dataScope.show = false">取消</el-button>
          <el-button type="primary" :loading="dataScope.saving" @click="saveDataScope">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "admin_group",
  data: function () {
    return {
      adminGroupList: [],
      showAddGroup: false,
      groups: [],
      validateRules: {
        name: [
          {required: true, message: '请输入用户组名称', trigger: 'blur'},
        ],
      },
      currGroup: {
        name: '',
        id: ''
      },
      privilege: {
        show:false,
        all_privilege_list: [],
        checked_privilege :[]
      },
      dataScope: {
        show: false,
        loading: false,
        saving: false,
        groupId: null,
        groupName: '',
        type: 12,
        filterText: '',
        catalog: [],
        selectedIds: [],
      },
      dataScopeTypeOptions: [
        { label: '线路', value: 10 },
        { label: '套票', value: 11 },
        { label: '景区', value: 12 },
        { label: '酒店', value: 13 },
        { label: '预约', value: 14 },
      ],
      loading: false
    }
  },
  computed: {
    filteredCatalog: function () {
      const rows = this.dataScope.catalog || [];
      const t = (this.dataScope.filterText || '').trim().toLowerCase();
      if (!t) {
        return rows;
      }
      return rows.filter(function (row) {
        const idStr = String(row.id);
        const title = (row.title || '').toLowerCase();
        const cate = (row.category_names || '').toLowerCase();
        return idStr.indexOf(t) !== -1 || title.indexOf(t) !== -1 || cate.indexOf(t) !== -1;
      });
    }
  },
  methods: {
    getGroupList: function () {
      this.$http.request('AdminGroupList').then(res => {
        this.adminGroupList = res.data;
      });
    },
    addGroup: function () {
      this.loading = true;
      this.$http.request('postAdminGroup', this.currGroup).then(res => {
        this.loading = false;
        if (res.status === 'success') {
          this.$message({message: res.message, type: 'success'});
          this.showAddGroup = false;
          this.currGroup = {
            name: '',
            id: ''
          };
          this.getGroupList();
        }
      });
    },
    edit: function (group) {
      this.showAddGroup = true;
      this.currGroup = {
        name: group.name,
        id: group.id
      };
    },
    openPutPrivilege:function (group){
      this.privilege.show = true;
      this.currGroup = {
        name: group.name,
        id: group.id
      };
      this.privilege.checked_privilege = [];
      let _self = this;
      this.$http.request('getPrivilegeList',{group_id:group.id}).then(res=>{
        _self.loading = false;
        if(res.status === 'success'){
          _self.privilege.all_privilege_list = res.data.all_privilege_list;
          res.data.has_privilege_list.forEach(row=>{
            _self.privilege.checked_privilege.push(row.privilege_id);
          })
        }
      });
    },
    putPrivileges:function (){
      this.loading = true;
      this.$http.request('putGroupPrivilege',{group_id:this.currGroup.id,privilege_ids:this.privilege.checked_privilege}).then(res=>{
        if(res.status ==='success'){
          this.loading = false;
          this.getGroupList();
          this.privilege.show = false;
        }
      })
    },
    openDataScope: function (group) {
      if (group.id === 1) {
        this.$message.warning('超级管理员组无需配置数据权限');
        return;
      }
      this.dataScope.groupId = group.id;
      this.dataScope.groupName = group.name;
      this.dataScope.type = 12;
      this.dataScope.filterText = '';
      this.dataScope.catalog = [];
      this.dataScope.selectedIds = [];
      this.dataScope.show = true;
      this.loadDataScopeCatalog(true);
    },
    onDataScopeTypeChange: function () {
      this.loadDataScopeCatalog(false);
    },
    loadDataScopeCatalog: function (syncSelectionFromServer) {
      const _self = this;
      this.dataScope.loading = true;
      this.$http.request('groupProductScope', {
        group_id: this.dataScope.groupId,
        type: this.dataScope.type,
      }).then(function (res) {
        _self.dataScope.loading = false;
        if (res.status !== 'success') {
          return;
        }
        _self.dataScope.catalog = res.data.catalog || [];
        if (syncSelectionFromServer) {
          _self.dataScope.selectedIds = (res.data.selected_product_ids || []).map(function (id) { return Number(id); });
        }
      }).catch(function () {
        _self.dataScope.loading = false;
      });
    },
    isProductSelected: function (id) {
      return this.dataScope.selectedIds.indexOf(Number(id)) !== -1;
    },
    toggleProduct: function (id, checked) {
      const nid = Number(id);
      const idx = this.dataScope.selectedIds.indexOf(nid);
      if (checked && idx === -1) {
        this.dataScope.selectedIds.push(nid);
      }
      if (!checked && idx !== -1) {
        this.dataScope.selectedIds.splice(idx, 1);
      }
    },
    selectAllFiltered: function () {
      const _self = this;
      this.filteredCatalog.forEach(function (row) {
        const nid = Number(row.id);
        if (_self.dataScope.selectedIds.indexOf(nid) === -1) {
          _self.dataScope.selectedIds.push(nid);
        }
      });
    },
    clearFilteredSelection: function () {
      const _self = this;
      const removeSet = {};
      this.filteredCatalog.forEach(function (row) {
        removeSet[Number(row.id)] = true;
      });
      this.dataScope.selectedIds = this.dataScope.selectedIds.filter(function (id) {
        return !removeSet[id];
      });
    },
    saveDataScope: function () {
      const _self = this;
      const payload = { group_id: this.dataScope.groupId };
      this.dataScope.selectedIds.forEach(function (id, index) {
        payload['product_ids[' + index + ']'] = id;
      });
      this.dataScope.saving = true;
      this.$http.request('putGroupProductScope', payload).then(function (res) {
        _self.dataScope.saving = false;
        if (res.status === 'success') {
          _self.$message.success(res.message || '保存成功');
          _self.dataScope.show = false;
        }
      }).catch(function () {
        _self.dataScope.saving = false;
      });
    },
    onDataScopeClose: function () {
      this.dataScope.catalog = [];
      this.dataScope.selectedIds = [];
    },
  },
  created: function () {
    this.getGroupList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/admin/admin_group.vue